module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/IfJ7SC/tc-custom/9781488096020.jpg?1728326946027",
      "alt": "This image is the cover for the book Very Special Delivery"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Very Special Delivery\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A single dad and his baby girl open up a world of possibilities for a beautiful outsider in ")]), _c('b', [_c('i', [_vm._v("New York Times")])]), _c('b', [_vm._v(" bestselling author Linda Goodnight’s classic love story…")]), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v("It was the surprise of a lifetime for recluse Molly McCreight when single dad Ethan Hunter entrusted her with his infant daughter while he delivered medicine to an elderly man during an ice storm. Past experience had taught Molly how fragile life could be, but she was touched by this stranger’s faith in her abilities. Once the storm had passed, though, and her guests returned home, normalcy eluded Molly. The Hunters’ presence had brought much-needed joy to her quiet world, but their absence threatened to crush her forever. Still, was she ready to admit that this tiny family held the key to the future she’d always secretly craved?"), _c('br'), _c('br'), _vm._v("Originally published in 2006\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Linda Goodnight\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("New York Times bestseller Linda Goodnight fell in love with words as a young child when her mother took her to a tiny library and let her fill a cardboard box with books. The next week she was back again, forever hooked on the beauty and power of the written word. Her other passions are her faith and her blended family. A former nurse and teacher, she lives in Oklahoma with her husband where she enjoys baking and travel. Connect with Linda at www.lindagoodnight.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises Limited\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0